import type { AnyNodeManifestDescriptive } from "@skilitics/nautilus-core";

/**
 * Whether resolving the parent's result or description also resolves this child's —
 * the design-time counterpart of the runtime's `child-result` reads, which is the hop
 * the binding graph alone cannot see.
 *
 * Two declared cases, both on the parent's own manifest (only the parent knows what
 * its own resolution reads):
 *
 * - the slot the parent wraps: the wrapped child's description and result are merged
 *   into the wrapper's on every read
 * - a slot flagged `foldsChildResult`: the parent folds the slot's child results into
 *   its own (e.g. an option's `hiders`/`disablers` predicates)
 *
 * An unflagged fold goes undetected rather than over-reported — publish rejects on a
 * cycle, so a false edge must never block a design that resolves fine at runtime.
 */
export const parentFoldsChildResult = (
  parentManifest: AnyNodeManifestDescriptive | undefined,
  slotName: string,
): boolean => parentManifest?.wraps === slotName || !!parentManifest?.children?.[slotName]?.foldsChildResult;
